/* eslint-disable-next-line */
export const _debug_translates:boolean = !!localStorage.getItem('_debug_translates') || false;
